// Polyfill :scope
import 'element-qsa-scope'

import { menuDesktop, menuMobile } from './header/menu.js';
import { checkout } from './pages/checkout.js';
import { slider } from './slider.js';
import popupProduct from './popupProduct';
import { custom_select } from './select.js';
import { filter } from './filter.js';
import updateQty from './updateQty.js';
import { reviews_tabs } from './tabs.js';
import facturationAddress from './facturationAddress.js';
import contactForm from './contactForm.js';
import { embedYTVideos } from './yt.js';
import newsletterPopup from './newsletterPopup';
import accountOrders from './accountOrders';
import categoryRedirect from './categoryRedirect';
import produit from './pages/produit';
import editAddresses from './editAddresses';
import networksFilters from './networksFilters';
import editAccount from './editAccount';
import faq from './faq';
import tagging from './tagging.js';
import landingpage from './pages/landingpage.js';

init();

function init() {
  // if (window.innerWidth > 1024) {
    menuDesktop();
    // }
  menuMobile();
  reviews_tabs();
  checkout();
  slider();
  popupProduct();
  updateQty();
  embedYTVideos();
  filter();
  facturationAddress();
  //custom_select();
  contactForm();
  newsletterPopup();
  accountOrders();
  categoryRedirect();
  produit();
  editAddresses();
  networksFilters();
  editAccount();
  faq();
  landingpage();
  tagging();
}
